// removed by extract-text-webpack-plugin
module.exports = {"containerFluid":"App-container-fluid","tableWrapper":"App-table-wrapper","tableWrapperShrinked":"App-table-wrapper-shrinked","sidebar":"App-sidebar","sidebarOpened":"App-sidebar-opened"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 144
// module chunks = 0